import { jsx as e } from "react/jsx-runtime";
import { forwardRef as t } from "react";
//#region src/components/controls/NavigationLink.tsx
var n = t(function({ linkConfig: t, ...n }, r) {
	let i = {
		...n,
		ref: r,
		href: t.href,
		target: t.target,
		rel: t.rel ?? (t.target === "_blank" ? "noopener noreferrer" : void 0)
	};
	return t.render ? t.render(i) : /* @__PURE__ */ e("a", {
		...i,
		children: i.children
	});
});
//#endregion
export { n as NavigationLink };
